import { VariantLookupLog } from '../../../product/dto/variant-lookup-log';
import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketVariantLookupResponse extends WebSocketReceiveMessage {
  override payload: VariantLookupLog;

  override onDeserialize() {
    this.payload = window?.injector?.Deserialize.instanceOf(VariantLookupLog, this.payload);
  }
}
